function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCombiBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M24 12A12 12 0 1 1 12 0a12 12 0 0 1 12 12",
    style: {
      fill: "#ff00b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2977.273 9804.869a1.5 1.5 0 1 1 1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-.33-8.27-5.306-5.271V9789h14.242v2.316l-5.318 5.229v3.448l-3.613 2.33zm.679 4.489 2.254-1.454v-2.806h-2.254zm-.229-4.993h2.66l4.861-4.779h-12.334zm-5.1-5.446h12.907v-.979h-12.9zm12.933 11.141v-3.97h2.018v3.97zm-3.276 0v-3.97h2.018v3.97zm-8.422 0v-3.97h2.021v3.97zm-3.531 0v-3.97h2.018v3.97z",
    transform: "translate(-2966.624 -9785.23)",
    style: {
      fill: "#fff",
      stroke: "transparent",
      strokeMiterlimit: 10
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombiBox);
export default __webpack_public_path__ + "static/media/combi-box.86702dfce26d7a5fd91e1c6f9470b7f1.svg";
export { ForwardRef as ReactComponent };